import { adminFetch } from '../../lib/adminFetch';
import React, { useState, useEffect, useMemo } from 'react';

// ML送信元アカウント（共有アカウントのみ。バックエンド admin-ml.php の ml_resolve_send_account と対応）
const ML_SEND_ACCOUNTS = [
  { key: 'news', email: 'news@srwith.com', label: 'news（配信・バウンス）' },
  { key: 'info', email: 'info@srwith.com', label: '事務局（共有・info）' },
  { key: 'academy', email: 'academy@srwith.com', label: 'academy（アカデミー会員）' },
  { key: 'infoweb', email: 'infoweb@srwith.com', label: 'infoweb（旧アドレス）' },
];

const MLAdmin = ({ initialTab = 'lists' }) => {
  const [customers, setCustomers] = useState([]);
  const [mlLists, setMlLists] = useState([]);
  const [dragIndex, setDragIndex] = useState(null);
  const [history, setHistory] = useState([]);
  const tab = initialTab;
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sendProgress, setSendProgress] = useState(null); // （旧・未使用）
  const [queue, setQueue] = useState([]); // 送信ジョブの状況

  // 送信フォーム
  const [selectedListId, setSelectedListId] = useState('');
  const [fromName, setFromName] = useState('SrWith株式会社 事務局'); // 差出人表示名
  const [fromKey, setFromKey] = useState('news'); // 送信元アカウント（news/info/academy/infoweb）
  const [appendSignature, setAppendSignature] = useState(true); // 末尾に署名を自動付与
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [attachments, setAttachments] = useState([]);
  const [confirmTargets, setConfirmTargets] = useState(null);
  const [confirmExcluded, setConfirmExcluded] = useState(0);
  // ブラックリスト（配信除外）
  const [blacklist, setBlacklist] = useState([]);
  const [showBlacklist, setShowBlacklist] = useState(false);
  const [blInput, setBlInput] = useState('');

  // 履歴詳細
  const [viewHistory, setViewHistory] = useState(null);

  // 下書き
  const [drafts, setDrafts] = useState([]);
  const [draftName, setDraftName] = useState('');
  const [showDraftSave, setShowDraftSave] = useState(false);

  // リスト詳細表示
  const [viewListId, setViewListId] = useState('');

  // 新規リスト作成
  const [showNewForm, setShowNewForm] = useState(false);
  const [newListName, setNewListName] = useState('');

  // CSVインポート
  const [showImport, setShowImport] = useState(false);
  const [csvHeader, setCsvHeader] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [map, setMap] = useState({ email: -1, name: -1, company: -1, phone: -1, label: -1 });
  const [importListName, setImportListName] = useState('');
  const [importLabel, setImportLabel] = useState('');
  const [importType, setImportType] = useState('company'); // 取り込む顧客の区分（企業/社労士）
  const [importFileName, setImportFileName] = useState('');
  const [importing, setImporting] = useState(false);

  // リスト編集
  const [editListId, setEditListId] = useState(null);
  const [editListName, setEditListName] = useState('');
  const [addEmail, setAddEmail] = useState('');

  // 顧客編集モーダル
  const [editForm, setEditForm] = useState(null);
  const [editSaving, setEditSaving] = useState(false);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    adminFetch('/api/admin-read.php?file=customers&t=' + Date.now()).then((r) => r.ok ? r.json() : []).then(setCustomers).catch(() => setCustomers([]));
    adminFetch('/api/admin-read.php?file=ml-lists&t=' + Date.now()).then((r) => r.ok ? r.json() : []).then(setMlLists).catch(() => setMlLists([]));
    adminFetch('/api/admin-read.php?file=events&t=' + Date.now()).then((r) => r.ok ? r.json() : []).then(setEvents).catch(() => setEvents([]));
    adminFetch('/api/admin-read.php?file=ml-history&t=' + Date.now()).then((r) => r.ok ? r.json() : []).then(setHistory).catch(() => setHistory([]));
    adminFetch('/api/admin-read.php?file=ml-drafts&t=' + Date.now()).then((r) => r.ok ? r.json() : []).then(setDrafts).catch(() => setDrafts([]));
    adminFetch('/api/admin-read.php?file=ml-blacklist&t=' + Date.now()).then((r) => r.ok ? r.json() : []).then((d) => setBlacklist(Array.isArray(d) ? d : [])).catch(() => setBlacklist([]));
    loadQueue();
  }, []);

  // 送信ジョブの状況を取得。処理中があれば処理をキック（cronを待たず進む・多重はサーバーのロックで防止）
  const loadQueue = () => {
    adminFetch('/api/admin-ml.php?action=queueStatus')
      .then((r) => (r.ok ? r.json() : { jobs: [] }))
      .then((d) => {
        const jobs = d.jobs || [];
        setQueue(jobs);
        if (jobs.some((j) => j.status === 'pending' || j.status === 'running')) {
          adminFetch('/api/admin-ml.php?action=process').catch(() => {});
        }
      })
      .catch(() => {});
  };

  // 15秒ごとに状況を更新（送信の進捗をリアルタイム表示）
  useEffect(() => {
    const t = setInterval(loadQueue, 15000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 送信中/待機中のジョブ
  const activeJobs = queue.filter((j) => j.status === 'pending' || j.status === 'running');

  // ブラックリスト操作
  const saveBlacklist = async (data) => {
    try {
      await adminFetch('/api/admin-data.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ file: 'ml-blacklist', data }) });
      setBlacklist(data);
    } catch {}
  };

  const addToBlacklist = () => {
    const emails = blInput.split(/[\n,;\s]+/).map((e) => e.trim().toLowerCase()).filter((e) => e && e.includes('@'));
    if (emails.length === 0) { setMessage('有効なメールアドレスがありません'); return; }
    const set = new Set(blacklist.map((b) => (b || '').toLowerCase()));
    const merged = [...blacklist];
    let added = 0;
    emails.forEach((e) => { if (!set.has(e)) { set.add(e); merged.push(e); added++; } });
    saveBlacklist(merged);
    setBlInput('');
    setMessage(`ブラックリストに${added}件追加しました`);
  };

  const removeFromBlacklist = (email) => saveBlacklist(blacklist.filter((b) => b !== email));

  // 送信履歴の失敗アドレスをまとめてブラックリストへ
  const addFailedToBlacklist = (emails) => {
    const clean = (emails || []).map((e) => (e || '').trim().toLowerCase()).filter((e) => e && e.includes('@'));
    if (clean.length === 0) { setMessage('追加できる失敗アドレスがありません'); return; }
    const set = new Set(blacklist.map((b) => (b || '').toLowerCase()));
    const merged = [...blacklist];
    let added = 0;
    clean.forEach((e) => { if (!set.has(e)) { set.add(e); merged.push(e); added++; } });
    saveBlacklist(merged);
    setMessage(`失敗アドレス${added}件をブラックリストに追加しました`);
  };

  const getField = (c, key) => (c.fields || []).find((f) => f.key === key)?.value || '';

  // リストのメンバー（emailsからCRM顧客を引き当て）
  const getMembers = (list) => {
    if (!list) return [];
    return (list.emails || []).map((email) => {
      const c = customers.find((c) => c.email === email);
      return c || { name: '', email, fields: [] };
    });
  };

  const selectedList = mlLists.find((l) => l.id === viewListId);
  const composeList = mlLists.find((l) => l.id === selectedListId);

  // リスト保存
  const saveMlLists = async (data) => {
    try {
      await adminFetch('/api/admin-data.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ file: 'ml-lists', data }) });
      setMlLists(data);
    } catch {}
  };

  const createList = () => {
    if (!newListName.trim()) return;
    const newList = { id: String(Date.now()), name: newListName.trim(), emails: [], createdAt: new Date().toISOString() };
    saveMlLists([...mlLists, newList]);
    setNewListName('');
    setShowNewForm(false);
    setMessage(`「${newList.name}」を作成しました`);
  };

  // --- CSVインポート ---
  // CSVをパース（ダブルクオート内のカンマ・改行に対応）
  const parseCSV = (text) => {
    const rows = [];
    let row = [], field = '', inQuotes = false;
    for (let i = 0; i < text.length; i++) {
      const c = text[i];
      if (inQuotes) {
        if (c === '"') {
          if (text[i + 1] === '"') { field += '"'; i++; }
          else inQuotes = false;
        } else field += c;
      } else if (c === '"') inQuotes = true;
      else if (c === ',') { row.push(field); field = ''; }
      else if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; }
      else if (c === '\r') { /* skip */ }
      else field += c;
    }
    if (field !== '' || row.length) { row.push(field); rows.push(row); }
    return rows.filter((r) => r.some((v) => (v || '').trim() !== ''));
  };

  // 見出しから各項目の列を自動推定
  const autoDetect = (header) => {
    const hl = header.map((h) => (h || '').trim().toLowerCase());
    const find = (cands) => hl.findIndex((h) => h && cands.some((c) => h.includes(c)));
    const email = find(['email', 'e-mail', 'メールアドレス', 'メール', 'mail', 'アドレス']);
    const person = find(['氏名', '名前', 'お名前', '担当', 'name']);
    const companyExplicit = find(['法人名', '会社名', '会社', '企業', '団体', 'company']);
    const facility = find(['事業所名', '施設名', '店舗名', '事業所', '施設', '店舗']);
    // 会社名：会社名/法人名の列があればそれ。無ければ施設名・事業所名を会社名に入れる（会社名で統一）
    const company = companyExplicit !== -1 ? companyExplicit : facility;
    // 名前：人名列があればそれ。無ければ、会社名に使っていない施設名系があればそれ、なければ空。
    let name = person;
    if (name === -1) name = (facility !== -1 && facility !== company ? facility : -1);
    const phone = find(['電話', 'tel', 'phone', '連絡先']);
    const label = find(['区分', 'カテゴリ', '分類', '業種', 'ジャンル']);
    return { email, name, company, phone, label };
  };

  const handleImportFile = (file) => {
    if (!file) return;
    setImportFileName(file.name);
    const reader = new FileReader();
    reader.onload = (e) => {
      const buf = e.target.result;
      let text;
      try { text = new TextDecoder('utf-8', { fatal: true }).decode(buf); }
      catch { try { text = new TextDecoder('shift-jis').decode(buf); } catch { text = new TextDecoder('utf-8').decode(buf); } }
      const rows = parseCSV(text);
      if (!rows.length) { setCsvHeader([]); setCsvData([]); return; }
      // 1行目に@が含まれていれば見出し無しとみなす
      const hasHeader = !rows[0].some((v) => (v || '').includes('@'));
      const header = hasHeader ? rows[0] : rows[0].map((_, i) => `列${i + 1}`);
      const data = hasHeader ? rows.slice(1) : rows;
      setCsvHeader(header);
      setCsvData(data);
      setMap(autoDetect(header));
      setImportListName((prev) => prev || file.name.replace(/\.[^.]+$/, ''));
    };
    reader.readAsArrayBuffer(file);
  };

  // マッピングに基づく取り込み行（プレビュー・インポート共通）
  const mappedRows = useMemo(() => {
    if (map.email < 0) return [];
    const g = (r, idx) => (idx >= 0 ? (r[idx] || '').trim() : '');
    return csvData
      .map((r) => ({
        email: g(r, map.email),
        name: g(r, map.name),
        company: g(r, map.company),
        phone: g(r, map.phone),
        label: g(r, map.label),
      }))
      .filter((x) => x.email && x.email.includes('@'));
  }, [csvData, map]);

  const resetImport = () => {
    setShowImport(false); setCsvHeader([]); setCsvData([]);
    setMap({ email: -1, name: -1, company: -1, phone: -1, label: -1 });
    setImportListName(''); setImportLabel(''); setImportType('company'); setImportFileName('');
  };

  const doImport = async () => {
    if (!importListName.trim()) { setMessage('リスト名を入力してください'); return; }
    if (mappedRows.length === 0) { setMessage('有効なメールアドレスがありません（メール列を選択してください）'); return; }
    setImporting(true);
    try {
      const fixedLabel = importLabel.trim();

      // メール重複排除（元の表記を保持）
      const seen = new Set();
      const uniqueEmails = [];
      mappedRows.forEach((r) => {
        const el = r.email.toLowerCase();
        if (!seen.has(el)) { seen.add(el); uniqueEmails.push(r.email); }
      });

      // MLリスト作成
      const newList = { id: String(Date.now()), name: importListName.trim(), emails: uniqueEmails, createdAt: new Date().toISOString() };
      const updatedLists = [...mlLists, newList];

      // 既存顧客はコピーして、ラベル付与できるようにする
      const working = customers.map((c) => ({ ...c }));
      const byEmail = new Map(working.map((c) => [c.email?.toLowerCase(), c]));
      const handled = new Set();
      const newCustomers = [];
      let touchedExisting = 0;
      mappedRows.forEach((r, i) => {
        const el = r.email.toLowerCase();
        if (handled.has(el)) return;
        handled.add(el);
        const rowLabel = r.label || fixedLabel; // 列のラベルがあれば優先、無ければ固定ラベル
        const existing = byEmail.get(el);
        if (existing) {
          if (rowLabel) {
            const fields = existing.fields || [];
            if (!fields.some((f) => f.key === 'ラベル' && f.value === rowLabel)) {
              existing.fields = [...fields, { key: 'ラベル', value: rowLabel }];
              touchedExisting++;
            }
          }
        } else {
          const fields = [];
          if (r.company) fields.push({ key: '会社名', value: r.company });
          if (r.phone) fields.push({ key: '電話番号', value: r.phone });
          if (rowLabel) fields.push({ key: 'ラベル', value: rowLabel });
          newCustomers.push({
            id: `${Date.now()}_${i}`, name: r.name || '', email: r.email,
            type: importType, status: '見込み', memo: '', fields,
          });
        }
      });

      await saveMlLists(updatedLists);
      if (newCustomers.length > 0 || touchedExisting > 0) {
        const updatedCustomers = [...working, ...newCustomers];
        await adminFetch('/api/admin-data.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ file: 'customers', data: updatedCustomers }) });
        setCustomers(updatedCustomers);
      }
      resetImport();
      const parts = [`${uniqueEmails.length}件`];
      if (newCustomers.length > 0) parts.push(`新規顧客${newCustomers.length}件`);
      setMessage(`「${newList.name}」を作成しました（${parts.join('／')}）`);
    } catch {
      setMessage('インポートに失敗しました');
    } finally {
      setImporting(false);
    }
  };

  const deleteList = (id) => {
    if (!window.confirm('このリストを削除しますか？')) return;
    saveMlLists(mlLists.filter((l) => l.id !== id));
    if (viewListId === id) setViewListId('');
    setMessage('削除しました');
  };

  // D&Dで順番変更
  const handleDragStart = (index) => setDragIndex(index);
  const handleDragOver = (e) => e.preventDefault();
  const handleDrop = (dropIndex) => {
    if (dragIndex === null || dragIndex === dropIndex) return;
    const reordered = [...mlLists];
    const [moved] = reordered.splice(dragIndex, 1);
    reordered.splice(dropIndex, 0, moved);
    saveMlLists(reordered);
    setDragIndex(null);
  };

  const startEditList = (list) => {
    setEditListId(list.id);
    setEditListName(list.name);
  };

  const saveListName = () => {
    if (!editListName.trim() || !editListId) return;
    saveMlLists(mlLists.map((l) => l.id === editListId ? { ...l, name: editListName.trim() } : l));
    setEditListId(null);
    setMessage('リスト名を変更しました');
  };

  const addEmailToList = async (listId) => {
    if (!addEmail.trim()) return;
    const emails = addEmail.split(/[\n,;]/).map((e) => e.trim()).filter((e) => e && e.includes('@'));
    if (emails.length === 0) return;

    // MLリストに追加
    saveMlLists(mlLists.map((l) => {
      if (l.id !== listId) return l;
      const existing = new Set(l.emails || []);
      emails.forEach((e) => existing.add(e));
      return { ...l, emails: [...existing] };
    }));

    // CRM未登録のメールアドレスを自動登録
    const existingEmails = new Set(customers.map((c) => c.email?.toLowerCase()).filter(Boolean));
    const newCustomers = emails
      .filter((e) => !existingEmails.has(e.toLowerCase()))
      .map((e, i) => ({
        id: Date.now() + '_' + i,
        name: '',
        email: e,
        type: 'company',
        status: '見込み',
        memo: '',
        fields: [],
      }));

    if (newCustomers.length > 0) {
      const updated = [...customers, ...newCustomers];
      try {
        await adminFetch('/api/admin-data.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ file: 'customers', data: updated }) });
        setCustomers(updated);
      } catch {}
    }

    setAddEmail('');
    setMessage(`${emails.length}件追加しました${newCustomers.length > 0 ? `（${newCustomers.length}件を顧客に新規登録）` : ''}`);
  };

  const removeEmailFromList = (listId, email) => {
    saveMlLists(mlLists.map((l) => {
      if (l.id !== listId) return l;
      return { ...l, emails: (l.emails || []).filter((e) => e !== email) };
    }));
  };

  // 送信確認
  const prepareConfirm = () => {
    if (!subject.trim() || !body.trim()) { setMessage('件名と本文を入力してください'); return; }
    const emails = composeList?.emails || [];
    if (emails.length === 0) { setMessage('送信先がありません'); return; }
    // ブラックリスト（配信除外）を宛先から外す
    const blSet = new Set(blacklist.map((b) => (b || '').toLowerCase()));
    const filtered = emails.filter((e) => !blSet.has((e || '').toLowerCase()));
    const excluded = emails.length - filtered.length;
    if (filtered.length === 0) { setMessage('送信先が全てブラックリストに含まれています'); return; }
    setConfirmExcluded(excluded);
    setConfirmTargets(filtered);
  };

  // 一斉送信（大量件数はタイムアウト回避のため分割送信）
  // サーバー側バッチ送信：ジョブを登録するだけ。あとはサーバー(cron)が送る。
  const sendML = async () => {
    if (!confirmTargets) return;
    setSending(true);
    setMessage('');
    try {
      const formData = new FormData();
      formData.append('subject', subject);
      formData.append('body', body);
      formData.append('fromName', fromName);
      formData.append('fromKey', fromKey);
      formData.append('appendSignature', appendSignature ? '1' : '0');
      formData.append('emails', JSON.stringify(confirmTargets));
      attachments.forEach((file) => formData.append('attachments[]', file));
      const res = await adminFetch('/api/admin-ml.php?action=enqueue', { method: 'POST', body: formData });
      const data = await res.json();
      if (data.success) {
        setMessage(`送信をサーバーに登録しました（${data.total}件）。バックグラウンドで送信します。この画面を閉じても止まりません。`);
        setSubject(''); setBody(''); setAttachments([]); setConfirmTargets(null);
        // cronを待たずにすぐ処理開始（結果は待たない）
        adminFetch('/api/admin-ml.php?action=process').catch(() => {});
        loadQueue();
      } else {
        setMessage('送信登録に失敗しました: ' + (data.message || ''));
      }
    } catch {
      setMessage('送信登録に失敗しました');
    } finally {
      setSending(false);
    }
  };

  // 顧客編集
  const openEditModal = (customer) => {
    if (!customer.id) {
      // CRM未登録の場合、メールアドレスから顧客を検索
      const found = customers.find((c) => c.email === customer.email);
      if (found) {
        setEditForm({ ...found, fields: [...(found.fields || [])] });
      }
      return;
    }
    setEditForm({ ...customer, fields: [...(customer.fields || [])] });
  };

  const saveCustomerEdit = async () => {
    if (!editForm) return;
    setEditSaving(true);
    try {
      const updated = customers.map((c) => c.id === editForm.id ? editForm : c);
      const res = await adminFetch('/api/admin-data.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ file: 'customers', data: updated }) });
      const result = await res.json();
      if (result.success) { setCustomers(updated); setEditForm(null); setMessage('保存しました'); }
    } catch {}
    setEditSaving(false);
  };

  // 下書き
  const saveDrafts = async (data) => {
    try {
      await adminFetch('/api/admin-data.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ file: 'ml-drafts', data }) });
      setDrafts(data);
    } catch {}
  };

  const saveDraft = () => {
    if (!draftName.trim() || (!subject.trim() && !body.trim())) return;
    const draft = { id: String(Date.now()), name: draftName.trim(), subject, body, createdAt: new Date().toISOString() };
    saveDrafts([...drafts, draft]);
    setDraftName('');
    setShowDraftSave(false);
    setMessage(`下書き「${draft.name}」を保存しました`);
  };

  const loadDraft = (draft) => {
    setSubject(draft.subject);
    setBody(draft.body);
    setMessage(`下書き「${draft.name}」を読み込みました`);
  };

  const deleteDraft = (id) => {
    saveDrafts(drafts.filter((d) => d.id !== id));
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('ja-JP') + ' ' + d.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">
        {tab === 'lists' ? 'MLリスト一覧' : tab === 'compose' ? 'ML一斉送信' : 'ML送信履歴'}
      </h2>

      {message && <div className="mb-4 px-4 py-2 bg-green-100 text-green-800 rounded-lg text-sm">{message}</div>}

      {/* リスト一覧 */}
      {tab === 'lists' && (
        <div className="flex gap-6">
          <div className="w-1/3">
            <div className="flex gap-2 mb-3">
              <button onClick={() => { setShowNewForm(true); setShowImport(false); }} className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-bold hover:bg-blue-700">+ 新規リスト作成</button>
              <button onClick={() => { setShowImport(true); setShowNewForm(false); }} className="flex-1 bg-white border border-blue-600 text-blue-600 px-4 py-2 rounded-lg text-sm font-bold hover:bg-blue-50">CSVインポート</button>
            </div>

            {showImport && (
              <div className="bg-white rounded-xl shadow p-4 mb-3">
                <p className="text-sm font-bold text-gray-700 mb-2">CSVから新規リスト作成</p>
                <p className="text-[11px] text-gray-400 mb-2">CSVを選ぶと列を自動判定します。下のマッピングで調整できます。Shift-JIS/UTF-8対応。</p>
                <input type="text" value={importListName} onChange={(e) => setImportListName(e.target.value)}
                  placeholder="リスト名" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm mb-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                <div className="mb-2">
                  <label className="block text-xs font-bold text-gray-600 mb-1">区分（新規登録する顧客の種別）</label>
                  <select value={importType} onChange={(e) => setImportType(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option value="company">企業</option>
                    <option value="sr">社労士</option>
                  </select>
                </div>
                <label className="block mb-2">
                  <span className="inline-block bg-gray-100 text-gray-700 px-3 py-1.5 rounded text-xs font-bold cursor-pointer hover:bg-gray-200">CSVファイルを選択</span>
                  {importFileName && <span className="ml-2 text-xs text-gray-500">{importFileName}</span>}
                  <input type="file" accept=".csv,text/csv" className="hidden" onChange={(e) => handleImportFile(e.target.files[0])} />
                </label>

                {csvHeader.length > 0 && (
                  <div className="mb-2 bg-gray-50 rounded-lg p-3">
                    <p className="text-xs font-bold text-gray-600 mb-2">列マッピング（どの列を使うか）</p>
                    <div className="grid grid-cols-2 gap-2">
                      {[
                        { key: 'email', label: 'メール *' },
                        { key: 'name', label: '名前' },
                        { key: 'company', label: '会社名' },
                        { key: 'phone', label: '電話番号' },
                        { key: 'label', label: 'ラベル列' },
                      ].map((f) => (
                        <label key={f.key} className="text-[11px] font-bold text-gray-600">
                          {f.label}
                          <select value={map[f.key]} onChange={(e) => setMap((m) => ({ ...m, [f.key]: Number(e.target.value) }))}
                            className="mt-0.5 w-full border border-gray-300 rounded px-1.5 py-1 text-xs font-normal focus:outline-none focus:ring-2 focus:ring-blue-500">
                            <option value={-1}>（なし）</option>
                            {csvHeader.map((h, i) => <option key={i} value={i}>{h}</option>)}
                          </select>
                        </label>
                      ))}
                    </div>
                    <p className="text-[10px] text-gray-400 mt-1">「ラベル列」を選ぶと各行のその列の値がラベルになります（例: 区分=介護/障害福祉）。未選択なら下の固定ラベルを使用。</p>
                  </div>
                )}

                <input type="text" value={importLabel} onChange={(e) => setImportLabel(e.target.value)}
                  placeholder="固定ラベル（任意・ラベル列が無い時に全員へ付与）" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm mb-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />

                {mappedRows.length > 0 && (
                  <div className="mb-2">
                    <p className="text-xs font-bold text-gray-600 mb-1">プレビュー（{mappedRows.length}件）</p>
                    <div className="border border-gray-200 rounded max-h-40 overflow-y-auto">
                      <table className="w-full text-[11px]">
                        <thead className="bg-gray-50 sticky top-0"><tr><th className="text-left px-2 py-1">名前</th><th className="text-left px-2 py-1">会社名</th><th className="text-left px-2 py-1">電話</th><th className="text-left px-2 py-1">ラベル</th><th className="text-left px-2 py-1">メール</th></tr></thead>
                        <tbody className="divide-y">
                          {mappedRows.slice(0, 20).map((r, i) => (
                            <tr key={i}><td className="px-2 py-1">{r.name || '-'}</td><td className="px-2 py-1 text-gray-500">{r.company || '-'}</td><td className="px-2 py-1 text-gray-500">{r.phone || '-'}</td><td className="px-2 py-1 text-gray-500">{r.label || importLabel || '-'}</td><td className="px-2 py-1 text-gray-500">{r.email}</td></tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {mappedRows.length > 20 && <p className="text-[10px] text-gray-400 mt-1">先頭20件を表示（全{mappedRows.length}件を取り込みます）</p>}
                  </div>
                )}
                <div className="flex gap-2">
                  <button onClick={doImport} disabled={importing || !importListName.trim() || mappedRows.length === 0}
                    className="bg-blue-600 text-white px-4 py-1.5 rounded text-xs font-bold hover:bg-blue-700 disabled:opacity-50">
                    {importing ? '取込中...' : `インポート${mappedRows.length ? `（${mappedRows.length}件）` : ''}`}
                  </button>
                  <button onClick={resetImport} className="bg-gray-200 text-gray-700 px-4 py-1.5 rounded text-xs font-bold hover:bg-gray-300">キャンセル</button>
                </div>
              </div>
            )}

            {showNewForm && (
              <div className="bg-white rounded-xl shadow p-4 mb-3">
                <input type="text" value={newListName} onChange={(e) => setNewListName(e.target.value)}
                  placeholder="リスト名を入力" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm mb-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  onKeyDown={(e) => e.key === 'Enter' && createList()} autoFocus />
                <div className="flex gap-2">
                  <button onClick={createList} disabled={!newListName.trim()} className="bg-blue-600 text-white px-4 py-1.5 rounded text-xs font-bold hover:bg-blue-700 disabled:opacity-50">作成</button>
                  <button onClick={() => { setShowNewForm(false); setNewListName(''); }} className="bg-gray-200 text-gray-700 px-4 py-1.5 rounded text-xs font-bold hover:bg-gray-300">キャンセル</button>
                </div>
              </div>
            )}

            {mlLists.length === 0 ? (
              <div className="bg-white rounded-xl shadow p-8 text-center text-gray-500 text-sm">リストがありません</div>
            ) : (
              <div className="bg-white rounded-xl shadow overflow-hidden">
                <div className="px-4 py-3 bg-gray-50 border-b text-xs text-gray-500 font-bold">{mlLists.length}件のリスト</div>
                <div className="divide-y max-h-[60vh] overflow-y-auto">
                  {mlLists.map((list, index) => (
                    <div key={list.id} onClick={() => setViewListId(list.id)}
                      draggable onDragStart={() => handleDragStart(index)} onDragOver={handleDragOver} onDrop={() => handleDrop(index)}
                      className={`px-4 py-3 hover:bg-gray-50 transition-colors cursor-pointer ${viewListId === list.id ? 'bg-blue-50' : ''} ${dragIndex === index ? 'opacity-50' : ''}`}>
                      {editListId === list.id ? (
                        <div className="flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
                          <input type="text" value={editListName} onChange={(e) => setEditListName(e.target.value)}
                            className="flex-1 border border-gray-300 rounded px-2 py-1 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onKeyDown={(e) => e.key === 'Enter' && saveListName()} autoFocus />
                          <button onClick={saveListName} className="bg-blue-600 text-white px-2.5 py-1 rounded text-[10px] font-bold hover:bg-blue-700">保存</button>
                          <button onClick={() => setEditListId(null)} className="bg-gray-200 text-gray-600 px-2.5 py-1 rounded text-[10px] font-bold hover:bg-gray-300">取消</button>
                        </div>
                      ) : (
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="font-bold text-sm">{list.name}</p>
                            <p className="text-xs text-gray-500 mt-0.5">{(list.emails || []).length}件</p>
                          </div>
                          <div className="flex gap-1.5" onClick={(e) => e.stopPropagation()}>
                            <button onClick={() => startEditList(list)} className="bg-gray-100 text-gray-600 px-2.5 py-1 rounded text-[10px] font-bold hover:bg-gray-200">名前変更</button>
                            <button onClick={() => deleteList(list.id)} className="bg-red-50 text-red-600 px-2.5 py-1 rounded text-[10px] font-bold hover:bg-red-100">削除</button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="flex-1">
            {selectedList ? (
              <div className="bg-white rounded-xl shadow overflow-hidden">
                <div className="px-4 py-3 bg-gray-50 border-b flex items-center justify-between">
                  <span className="font-bold text-sm">{selectedList.name}</span>
                  <span className="text-xs text-gray-500">{(selectedList.emails || []).length}件</span>
                </div>

                {/* メンバー追加 */}
                <div className="px-4 py-3 border-b bg-gray-50 space-y-2">
                  <div className="flex gap-2">
                    <input type="text" value={addEmail} onChange={(e) => setAddEmail(e.target.value)}
                      placeholder="名前・メールで検索して追加、またはメールアドレスを直接入力"
                      className="flex-1 border border-gray-300 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500"
                      onKeyDown={(e) => e.key === 'Enter' && addEmailToList(selectedList.id)} />
                    <button onClick={() => addEmailToList(selectedList.id)} className="bg-blue-500 text-white px-3 py-1.5 rounded text-xs font-bold hover:bg-blue-600">追加</button>
                  </div>
                  {addEmail.trim() && !addEmail.includes('@') && (() => {
                    const s = addEmail.toLowerCase();
                    const listEmails = new Set(selectedList.emails || []);
                    const matches = customers.filter((c) => c.email && !listEmails.has(c.email) &&
                      (c.name.toLowerCase().includes(s) || c.email.toLowerCase().includes(s) || getField(c, '会社名').toLowerCase().includes(s))
                    ).slice(0, 8);
                    return matches.length > 0 ? (
                      <div className="border border-gray-200 rounded bg-white max-h-40 overflow-y-auto">
                        {matches.map((c) => (
                          <button key={c.id} onClick={() => { setAddEmail(c.email); }}
                            className="w-full text-left px-3 py-1.5 hover:bg-blue-50 text-xs flex items-center justify-between border-b last:border-b-0">
                            <span><span className="font-bold">{c.name}</span> <span className="text-gray-400">{getField(c, '会社名')}</span></span>
                            <span className="text-gray-400">{c.email}</span>
                          </button>
                        ))}
                      </div>
                    ) : null;
                  })()}
                </div>

                <div className="max-h-[55vh] overflow-y-auto">
                  <table className="w-full text-xs">
                    <thead className="bg-gray-50 sticky top-0">
                      <tr>
                        <th className="text-left px-3 py-2">名前</th>
                        <th className="text-left px-3 py-2">会社名</th>
                        <th className="text-left px-3 py-2">メール</th>
                        <th className="text-left px-3 py-2">区分</th>
                        <th className="text-left px-3 py-2">ステータス</th>
                        <th className="px-3 py-2 w-16"></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y">
                      {getMembers(selectedList).map((c, i) => (
                        <tr key={i} className="hover:bg-gray-50 cursor-pointer" onClick={() => openEditModal(c)}>
                          <td className="px-3 py-2 text-blue-600 hover:underline">{c.name || '-'}</td>
                          <td className="px-3 py-2 text-gray-500">{getField(c, '会社名')}</td>
                          <td className="px-3 py-2 text-gray-500">{c.email}</td>
                          <td className="px-3 py-2">
                            {c.type && <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${c.type === 'sr' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'}`}>{c.type === 'sr' ? '社労士' : '企業'}</span>}
                          </td>
                          <td className="px-3 py-2">
                            <div className="flex flex-wrap gap-0.5">
                              {(c.salesStatus || c.status) && <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${{ '見込み': 'bg-yellow-100 text-yellow-700', '商談中': 'bg-blue-100 text-blue-700', '休止': 'bg-gray-100 text-gray-500' }[c.salesStatus || c.status] || 'bg-gray-100 text-gray-600'}`}>{c.salesStatus || c.status}</span>}
                              {c.srwithContract === 'あり' && <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-green-100 text-green-700">SrWith</span>}
                              {c.academyStatus === '受講中' && <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-emerald-100 text-emerald-700">アカデミー</span>}
                            </div>
                          </td>
                          <td className="px-3 py-2 text-center" onClick={(e) => e.stopPropagation()}>
                            <button onClick={() => removeEmailFromList(selectedList.id, c.email)} className="bg-red-50 text-red-600 px-2 py-0.5 rounded text-[10px] font-bold hover:bg-red-100">削除</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="px-4 py-3 border-t">
                  <button onClick={() => { setSelectedListId(selectedList.id); window.location.hash = 'ml_compose'; }}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg text-xs font-bold hover:bg-blue-700">
                    このリストにメール送信
                  </button>
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow p-8 text-center text-gray-500">左のリストを選択してください</div>
            )}
          </div>
        </div>
      )}

      {/* メール作成 */}
      {tab === 'compose' && (
        <>
        {/* 送信状況（サーバー側バッチ送信） */}
        {queue.length > 0 && (
          <div className="bg-white rounded-xl shadow p-4 mb-4">
            <div className="flex items-center justify-between mb-2">
              <p className="text-sm font-bold text-gray-700">送信状況</p>
              <button onClick={loadQueue} className="text-xs text-blue-600 font-bold hover:underline">更新</button>
            </div>
            <div className="space-y-2">
              {queue.slice(0, 6).map((j) => {
                const pct = j.total ? Math.round((j.cursor / j.total) * 100) : 0;
                const label = j.status === 'done' ? '完了' : j.status === 'running' ? '送信中' : j.status === 'pending' ? '待機中' : j.status;
                const color = j.status === 'done' ? 'bg-green-500' : 'bg-blue-500';
                return (
                  <div key={j.id} className="text-xs">
                    <div className="flex items-center justify-between mb-0.5">
                      <span className="font-bold text-gray-700 truncate mr-2">{j.subject}</span>
                      <span className={`shrink-0 px-2 py-0.5 rounded font-bold ${j.status === 'done' ? 'bg-green-100 text-green-700' : j.status === 'running' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'}`}>
                        {label} {j.cursor || 0}/{j.total || 0}{j.failCount > 0 ? `（失敗${j.failCount}）` : ''}
                      </span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
                      <div className={`h-1.5 ${color}`} style={{ width: `${pct}%` }} />
                    </div>
                  </div>
                );
              })}
            </div>
            <p className="text-[10px] text-gray-400 mt-2">送信はサーバーで処理中です。この画面を閉じても継続します（最大数分の遅延で自動進行）。</p>
          </div>
        )}
        <div className="bg-white rounded-xl shadow p-6">
          <div className="mb-5">
            <label className="block text-sm font-bold mb-2">送信先リスト</label>
            <div className="flex flex-wrap gap-2">
              {mlLists.map((list) => (
                <button key={list.id} onClick={() => setSelectedListId(list.id)}
                  className={`px-4 py-2 rounded-lg text-xs font-bold ${selectedListId === list.id ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
                  {list.name}（{(list.emails || []).length}件）
                </button>
              ))}
            </div>
            {composeList && <p className="mt-2 text-sm text-gray-500 font-bold">送信先: {(composeList.emails || []).length}件</p>}
          </div>

          <div className="mb-4">
            <label className="block text-sm font-bold mb-1">送信元アカウント</label>
            <select value={fromKey} onChange={(e) => setFromKey(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              {ML_SEND_ACCOUNTS.map((a) => <option key={a.key} value={a.key}>{a.label}（{a.email}）</option>)}
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-bold mb-1">差出人</label>
            <select value={fromName} onChange={(e) => setFromName(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="SrWith株式会社 事務局">SrWith株式会社 事務局</option>
              <option value="社会保険労務士 塚本祥太郎">社会保険労務士 塚本祥太郎</option>
            </select>
            <p className="text-[11px] text-gray-400 mt-1">選んだ差出人が From 表示名と本文末尾の署名に反映されます（送信元アドレスは {ML_SEND_ACCOUNTS.find((a) => a.key === fromKey)?.email || 'news@srwith.com'}）。</p>
            <label className="inline-flex items-center gap-1.5 mt-2 cursor-pointer">
              <input type="checkbox" checked={appendSignature} onChange={(e) => setAppendSignature(e.target.checked)} />
              <span className="text-xs font-bold text-gray-700">末尾に署名を自動で付ける</span>
              <span className="text-[11px] text-gray-400 font-normal">（本文に署名を書く場合はOFFにすると二重になりません）</span>
            </label>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-bold mb-1">件名</label>
            <input type="text" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="メールの件名"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div className="mb-4">
            <div className="flex items-center justify-between mb-1">
              <label className="text-sm font-bold">本文</label>
              <div className="flex gap-1">
                {[
                  { tag: '{name}', label: '名前' },
                  { tag: '{company}', label: '会社名' },
                ].map((t) => (
                  <button key={t.tag} onClick={() => setBody((prev) => prev + t.tag)}
                    className="bg-gray-100 text-gray-600 px-2 py-0.5 rounded text-[10px] font-bold hover:bg-gray-200">{t.label}</button>
                ))}
              </div>
            </div>
            <textarea value={body} onChange={(e) => setBody(e.target.value)} rows={10} placeholder="メール本文を入力...&#10;&#10;{name} 様、{company} の件について..."
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none" />
          </div>
          <div className="mb-5">
            <label className="inline-flex items-center gap-1.5 cursor-pointer text-gray-500 hover:text-gray-700 text-sm">
              <span>📎</span><span className="text-xs font-bold">ファイルを添付</span><span className="text-[10px] text-gray-400 font-normal">（30MBまで）</span>
              <input type="file" multiple className="hidden" onChange={(e) => setAttachments((prev) => [...prev, ...Array.from(e.target.files)])} />
            </label>
            {attachments.length > 0 && (
              <div className="flex flex-wrap gap-1.5 mt-1.5">
                {attachments.map((file, i) => (
                  <span key={i} className="inline-flex items-center gap-1 bg-gray-100 rounded px-2 py-1 text-xs text-gray-700">
                    📎 {file.name}<button onClick={() => setAttachments((prev) => prev.filter((_, j) => j !== i))} className="text-red-400 hover:text-red-600 font-bold ml-0.5">×</button>
                  </span>
                ))}
              </div>
            )}
          </div>
          <div className="flex items-center gap-3 mb-6">
            <button onClick={prepareConfirm} disabled={sending || !subject.trim() || !body.trim() || !selectedListId}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg text-sm font-bold hover:bg-blue-700 disabled:opacity-50">送信確認</button>
            <button onClick={() => setShowDraftSave(true)} disabled={!subject.trim() && !body.trim()}
              className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg text-sm font-bold hover:bg-gray-300 disabled:opacity-50">下書き保存</button>
            <button onClick={() => setShowBlacklist(true)}
              className="ml-auto bg-white border border-gray-300 text-gray-700 px-4 py-2 rounded-lg text-sm font-bold hover:bg-gray-50">
              ブラックリスト{blacklist.length > 0 ? `（${blacklist.length}）` : ''}
            </button>
          </div>

          {showDraftSave && (
            <div className="mb-4 bg-gray-50 rounded-lg p-4 flex items-center gap-2">
              <input type="text" value={draftName} onChange={(e) => setDraftName(e.target.value)}
                placeholder="下書き名" className="flex-1 border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                onKeyDown={(e) => e.key === 'Enter' && saveDraft()} autoFocus />
              <button onClick={saveDraft} disabled={!draftName.trim()} className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-bold hover:bg-blue-700 disabled:opacity-50">保存</button>
              <button onClick={() => { setShowDraftSave(false); setDraftName(''); }} className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg text-sm font-bold hover:bg-gray-300">取消</button>
            </div>
          )}

          {drafts.length > 0 && (
            <div className="mb-6">
              <p className="text-sm font-bold text-gray-600 mb-2">下書き一覧</p>
              <div className="space-y-1.5">
                {drafts.map((d) => (
                  <div key={d.id} className="flex items-center justify-between bg-gray-50 rounded-lg px-4 py-2">
                    <div className="min-w-0">
                      <p className="text-xs font-bold text-gray-700">{d.name}</p>
                      <p className="text-[10px] text-gray-400 truncate">{d.subject || '(件名なし)'}</p>
                    </div>
                    <div className="flex gap-1.5 shrink-0 ml-2">
                      <button onClick={() => loadDraft(d)} className="bg-blue-100 text-blue-700 px-3 py-1 rounded text-[10px] font-bold hover:bg-blue-200">読み込み</button>
                      <button onClick={() => deleteDraft(d.id)} className="bg-red-50 text-red-600 px-3 py-1 rounded text-[10px] font-bold hover:bg-red-100">削除</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {confirmTargets && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
              <div className="bg-white rounded-xl shadow-xl p-6 max-w-lg w-full mx-4">
                <h3 className="font-bold text-lg mb-3">送信確認</h3>
                <div className="mb-3 text-sm">
                  <p><span className="font-bold">リスト:</span> {composeList?.name}</p>
                  <p className="mt-1"><span className="font-bold">件名:</span> {subject}</p>
                  <p className="mt-1"><span className="font-bold">送信先:</span> {confirmTargets.length}件</p>
                  <p className="mt-1"><span className="font-bold">差出人:</span> {fromName}</p>
                  {confirmExcluded > 0 && <p className="mt-1 text-orange-600"><span className="font-bold">ブラックリスト除外:</span> {confirmExcluded}件（送信しません）</p>}
                  {attachments.length > 0 && <p className="mt-1"><span className="font-bold">添付:</span> {attachments.map((f) => f.name).join(', ')}</p>}
                </div>
                <div className="max-h-40 overflow-y-auto border rounded-lg mb-4 p-2">
                  {confirmTargets.slice(0, 500).map((email, i) => <p key={i} className="text-xs text-gray-600 py-0.5">{email}</p>)}
                  {confirmTargets.length > 500 && <p className="text-xs text-gray-400 py-0.5">…ほか{confirmTargets.length - 500}件</p>}
                </div>
                <div className="mb-3 px-3 py-2 bg-blue-50 text-blue-800 rounded-lg text-xs">
                  📮 送信は<span className="font-bold">サーバー側でバックグラウンド処理</span>します。「送信する」を押したら登録完了、<span className="font-bold">この画面やPCを閉じても止まりません</span>。進捗は「送信状況」で確認できます（目安：約{Math.ceil(confirmTargets.length * 0.2 / 60)}分で完了）。
                </div>
                <div className="flex gap-3">
                  <button onClick={sendML} disabled={sending} className="bg-red-600 text-white px-6 py-2 rounded-lg text-sm font-bold hover:bg-red-700 disabled:opacity-50">
                    {sending ? '登録中...' : `${confirmTargets.length}件に送信する`}
                  </button>
                  <button onClick={() => setConfirmTargets(null)} disabled={sending} className="bg-gray-200 text-gray-700 px-6 py-2 rounded-lg text-sm font-bold hover:bg-gray-300 disabled:opacity-50">キャンセル</button>
                </div>
              </div>
            </div>
          )}
        </div>
        </>
      )}

      {/* 送信履歴 */}
      {tab === 'history' && (
        <div>
          {history.length === 0 ? (
            <div className="bg-white rounded-xl shadow p-8 text-center text-gray-500">送信履歴がありません</div>
          ) : (
            <div className="space-y-2">
              {[...history].reverse().map((h, i) => (
                <div key={i} onClick={() => setViewHistory(viewHistory === i ? null : i)}
                  className="bg-white rounded-xl shadow p-4 cursor-pointer hover:bg-gray-50 transition-colors">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3 min-w-0">
                      <p className="font-bold text-sm truncate">{h.subject}</p>
                      <div className="flex gap-1.5 shrink-0">
                        {h.fromName && <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded text-[10px] font-bold">差出人: {h.fromName}</span>}
                        {h.fromEmail && <span className="bg-indigo-50 text-indigo-600 px-2 py-0.5 rounded text-[10px] font-bold">{h.fromEmail}</span>}
                        <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-[10px] font-bold">成功 {h.sentCount}</span>
                        {h.failCount > 0 && <span className="bg-red-100 text-red-700 px-2 py-0.5 rounded text-[10px] font-bold">失敗 {h.failCount}</span>}
                        {h.attachments && h.attachments.length > 0 && <span className="text-[10px] text-gray-400">📎 {h.attachments.length}</span>}
                      </div>
                    </div>
                    <span className="text-xs text-gray-400 shrink-0">{formatDate(h.date)}</span>
                  </div>
                  {viewHistory === i && (
                    <div className="mt-3 border-t pt-3">
                      <p className="text-sm whitespace-pre-wrap text-gray-700 bg-gray-50 rounded-lg p-4 mb-3">{h.body}</p>
                      {h.attachments && h.attachments.length > 0 && (
                        <div className="mb-3 flex flex-wrap gap-1.5">{h.attachments.map((name, j) => <span key={j} className="text-xs text-gray-500">📎 {name}</span>)}</div>
                      )}
                      {h.failedEmails && h.failedEmails.length > 0 && (
                        <div className="mb-3">
                          <div className="flex items-center justify-between mb-1">
                            <p className="text-xs font-bold text-red-600">失敗アドレス（{h.failedEmails.length}件）</p>
                            <button onClick={(e) => { e.stopPropagation(); addFailedToBlacklist(h.failedEmails); }}
                              className="bg-red-50 text-red-600 px-3 py-1 rounded text-[10px] font-bold hover:bg-red-100">
                              失敗{h.failedEmails.length}件をブラックリストに追加
                            </button>
                          </div>
                          <div className="max-h-40 overflow-y-auto bg-red-50/40 rounded-lg p-3">
                            {h.failedEmails.slice(0, 300).map((email, j) => <p key={j} className="text-xs text-gray-600 py-0.5">{email}</p>)}
                            {h.failedEmails.length > 300 && <p className="text-xs text-gray-400 py-0.5">…ほか{h.failedEmails.length - 300}件（追加ボタンで全件登録されます）</p>}
                          </div>
                        </div>
                      )}
                      <div>
                        <p className="text-xs font-bold text-gray-500 mb-1">送信先（{h.emails.length}件）</p>
                        <div className="max-h-40 overflow-y-auto bg-gray-50 rounded-lg p-3">
                          {h.emails.slice(0, 300).map((email, j) => <p key={j} className="text-xs text-gray-600 py-0.5">{email}</p>)}
                          {h.emails.length > 300 && <p className="text-xs text-gray-400 py-0.5">…ほか{h.emails.length - 300}件</p>}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* 顧客編集モーダル */}
      {/* ブラックリスト（配信除外）管理 */}
      {showBlacklist && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setShowBlacklist(false)}>
          <div className="bg-white rounded-xl shadow-xl p-6 max-w-lg w-full max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-bold text-lg">ブラックリスト（配信除外）</h3>
              <button onClick={() => setShowBlacklist(false)} className="text-gray-400 hover:text-gray-600 text-xl leading-none">×</button>
            </div>
            <p className="text-xs text-gray-500 mb-3">ここに登録したアドレスは、ML一斉送信の宛先から自動的に除外されます（送信されません）。</p>
            <div className="flex gap-2 mb-4">
              <textarea value={blInput} onChange={(e) => setBlInput(e.target.value)} rows={2}
                placeholder="除外するメールアドレス（改行・カンマで複数可）"
                className="flex-1 border border-gray-300 rounded px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none" />
              <button onClick={addToBlacklist} className="bg-blue-600 text-white px-4 py-1.5 rounded text-sm font-bold hover:bg-blue-700 self-start">追加</button>
            </div>
            <p className="text-xs font-bold text-gray-600 mb-1">登録済み（{blacklist.length}件）</p>
            {blacklist.length === 0 ? (
              <p className="text-xs text-gray-400 py-2">まだありません</p>
            ) : (
              <div className="border border-gray-200 rounded max-h-64 overflow-y-auto divide-y">
                {blacklist.map((email, i) => (
                  <div key={i} className="flex items-center justify-between px-3 py-1.5">
                    <span className="text-xs text-gray-700 truncate">{email}</span>
                    <button onClick={() => removeFromBlacklist(email)} className="text-red-500 text-xs font-bold hover:text-red-700 shrink-0 ml-2">削除</button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {editForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-xl p-6 max-w-lg w-full mx-4 max-h-[85vh] overflow-y-auto">
            <h3 className="font-bold text-lg mb-4">顧客情報の編集</h3>
            <div className="space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-bold mb-1">姓</label>
                  <input type="text" value={(editForm.name || '').split(/\s+/)[0] || ''} onChange={(e) => {
                    const mei = (editForm.name || '').split(/\s+/).slice(1).join(' ');
                    setEditForm({ ...editForm, name: (e.target.value + ' ' + mei).trim() });
                  }} className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                </div>
                <div>
                  <label className="block text-xs font-bold mb-1">名</label>
                  <input type="text" value={(editForm.name || '').split(/\s+/).slice(1).join(' ') || ''} onChange={(e) => {
                    const sei = (editForm.name || '').split(/\s+/)[0] || '';
                    setEditForm({ ...editForm, name: (sei + ' ' + e.target.value).trim() });
                  }} className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                </div>
              </div>
              <div>
                <label className="block text-xs font-bold mb-1">メールアドレス</label>
                <input type="email" value={editForm.email} onChange={(e) => setEditForm({ ...editForm, email: e.target.value })}
                  className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-bold mb-1">区分</label>
                  <select value={editForm.type} onChange={(e) => setEditForm({ ...editForm, type: e.target.value })}
                    className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option value="company">企業</option><option value="sr">社労士</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-bold mb-1">営業</label>
                  <select value={editForm.salesStatus || editForm.status || '見込み'} onChange={(e) => setEditForm({ ...editForm, salesStatus: e.target.value })}
                    className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                    {['見込み', '商談中', '休止'].map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-bold mb-1">SrWith契約</label>
                  <select value={editForm.srwithContract || 'なし'} onChange={(e) => setEditForm({ ...editForm, srwithContract: e.target.value })}
                    className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                    {['なし', 'あり'].map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-bold mb-1">アカデミー</label>
                  <select value={editForm.academyStatus || '未受講'} onChange={(e) => setEditForm({ ...editForm, academyStatus: e.target.value })}
                    className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                    {['未受講', '受講中', '解約済み'].map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              </div>
              {/* 追加項目 */}
              {editForm.fields && editForm.fields.length > 0 && (
                <div>
                  <label className="text-xs font-bold mb-1 block">追加項目</label>
                  <div className="space-y-1.5">
                    {editForm.fields.map((field, i) => (
                      field.key === 'イベントID' ? (
                        <div key={i} className="flex gap-2 items-center">
                          <span className="w-1/3 text-xs font-bold text-gray-600">イベント</span>
                          <span className="flex-1 text-xs text-gray-700">{events.find((e) => e.id === field.value)?.name || field.value}</span>
                        </div>
                      ) : (
                        <div key={i} className="flex gap-2">
                          <input type="text" value={field.key} onChange={(e) => {
                            const fields = [...editForm.fields]; fields[i] = { ...fields[i], key: e.target.value }; setEditForm({ ...editForm, fields });
                          }} placeholder="項目名" className="w-1/3 border border-gray-300 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500" />
                          <input type="text" value={field.value} onChange={(e) => {
                            const fields = [...editForm.fields]; fields[i] = { ...fields[i], value: e.target.value }; setEditForm({ ...editForm, fields });
                          }} placeholder="値" className="flex-1 border border-gray-300 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500" />
                          <button onClick={() => setEditForm({ ...editForm, fields: editForm.fields.filter((_, j) => j !== i) })}
                            className="bg-red-50 text-red-600 px-2 py-1 rounded text-[10px] font-bold hover:bg-red-100">削除</button>
                        </div>
                      )
                    ))}
                  </div>
                </div>
              )}
              <button onClick={() => setEditForm({ ...editForm, fields: [...(editForm.fields || []), { key: '', value: '' }] })}
                className="text-xs text-blue-600 font-bold hover:underline">+ 項目追加</button>
              <div>
                <label className="block text-xs font-bold mb-1">メモ</label>
                <textarea value={editForm.memo} onChange={(e) => setEditForm({ ...editForm, memo: e.target.value })} rows={2}
                  className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none" />
              </div>
              <div className="flex gap-3 pt-2">
                <button onClick={saveCustomerEdit} disabled={editSaving || !editForm.name}
                  className="bg-blue-600 text-white px-6 py-2 rounded-lg text-sm font-bold hover:bg-blue-700 disabled:opacity-50">
                  {editSaving ? '保存中...' : '保存'}
                </button>
                <button onClick={() => setEditForm(null)} className="bg-gray-200 text-gray-700 px-6 py-2 rounded-lg text-sm font-bold hover:bg-gray-300">キャンセル</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MLAdmin;
